import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        backgroundColor: isScrolled ? 'rgba(26, 26, 46, 0.85)' : 'transparent',
        backdropFilter: isScrolled ? 'blur(10px)' : 'none',
        WebkitBackdropFilter: isScrolled ? 'blur(10px)' : 'none',
        boxShadow: isScrolled ? '0 2px 16px rgba(0,0,0,0.30)' : 'none',
        transition: 'background-color 0.3s ease, backdrop-filter 0.3s ease, box-shadow 0.3s ease',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/0726c5a5-f6f0-4a10-9808-4bd29d3ff1e9.png" 
              alt="CMC Construcción y Carpintería" 
              className="w-[120px] h-auto self-center"
            />
          </div>

          {/* Menu de navegación */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-base font-medium transition-colors hover:text-[#C9A86A] whitespace-nowrap text-white"
            >
              Inicio
            </button>
            <div className={`w-px h-4 ${isScrolled ? 'bg-gray-300' : 'bg-white/30'}`}></div>
            <button
              onClick={() => scrollToSection('servicios')}
              className="text-base font-medium transition-colors hover:text-[#C9A86A] whitespace-nowrap text-white"
            >
              Servicios
            </button>
            <div className={`w-px h-4 ${isScrolled ? 'bg-gray-300' : 'bg-white/30'}`}></div>
            <button
              onClick={() => scrollToSection('proyectos')}
              className="text-base font-medium transition-colors hover:text-[#C9A86A] whitespace-nowrap text-white"
            >
              Proyectos
            </button>
            <div className={`w-px h-4 ${isScrolled ? 'bg-gray-300' : 'bg-white/30'}`}></div>
            <button
              onClick={() => scrollToSection('zonas')}
              className="text-base font-medium transition-colors hover:text-[#C9A86A] whitespace-nowrap text-white"
            >
              Zonas de Servicio
            </button>
            <div className={`w-px h-4 ${isScrolled ? 'bg-gray-300' : 'bg-white/30'}`}></div>
            <button
              onClick={() => scrollToSection('nosotros')}
              className="text-base font-medium transition-colors hover:text-[#C9A86A] whitespace-nowrap text-white"
            >
              Nosotros
            </button>
            <div className={`w-px h-4 ${isScrolled ? 'bg-gray-300' : 'bg-white/30'}`}></div>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-base font-medium transition-colors hover:text-[#C9A86A] whitespace-nowrap text-white"
            >
              Contacto
            </button>
          </div>

          {/* Botones de acción */}
          <div className="hidden lg:flex items-center space-x-4">
            <button
              onClick={() => scrollToSection('contacto')}
              className="px-6 py-3 bg-[#C9A86A] text-[#1A1A2E] rounded-lg font-semibold hover:bg-[#B8935A] transition-colors whitespace-nowrap"
            >
              Cotizar Proyecto
            </button>
            <a
              href="https://wa.me/528447098387"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-[#25D366] rounded-full flex items-center justify-center hover:scale-110 transition-transform"
            >
              <i className="ri-whatsapp-line text-white text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}